import { defineMessages } from 'react-intl'

import { CONCILIATION_STATUS } from './constants'

export const conciliationStatusMessages = defineMessages({
  [CONCILIATION_STATUS.CONFLICTING]: {
    id: 'spanish.order.conciliation.status.conflicting',
    defaultMessage: 'Conflicto'
  },
  [CONCILIATION_STATUS.COMPLETED]: {
    id: 'spanish.order.conciliation.status.completed',
    defaultMessage: 'OK'
  }
})
